import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["submit"];

  connect() {
    this.validateAndToggle();
    this.element.addEventListener("input", this.validateAndToggle);
    this.element.addEventListener("change", this.validateAndToggle);
    this.element.addEventListener("click", this.validateAndToggle);
    this.element.addEventListener("turbo:frame-load", this.validateAndToggle);
  }

  disconnect() {
    this.element.removeEventListener("input", this.validateAndToggle);
    this.element.removeEventListener("change", this.validateAndToggle);
    this.element.removeEventListener("click", this.validateAndToggle);
    this.element.removeEventListener(
      "turbo:frame-load",
      this.validateAndToggle
    );
  }

  validateAndToggle = () => {
    const isValid = this.allRequiredFieldsFilled();
    this.toggleSubmitButton(isValid);
  };

  allRequiredFieldsFilled() {
    const fields = this.element.querySelectorAll("[required]:not([disabled])");
    return Array.from(fields).every((field) => this.isFieldFilled(field));
  }

  isFieldFilled(field) {
    if (field.type === "radio") {
      const radios = this.element.querySelectorAll(
        `input[type="radio"][name="${field.name}"]`
      );
      return Array.from(radios).some((r) => r.checked);
    }
    if (field.tagName.toLowerCase() === "select") {
      return field.value !== "";
    }
    return field.value.trim() !== "";
  }

  toggleSubmitButton(enable) {
    if (!this.hasSubmitTarget) return;
    enable
      ? this.submitTarget.removeAttribute("disabled")
      : this.submitTarget.setAttribute("disabled", true);
  }
}
